import CurrentUserService from '../../services/CurrentUserService'

const state = {
    CurrentUser: [],
}


const getters = {
    CurrentUser: state => {
        return state.CurrentUser
    },

}

const actions = {
    getCurrentUser({commit}){
        CurrentUserService.fetchCurrentUser()
        .then(currentuser => {
            commit('setCurrentuser', currentuser)
        })
    }
    
    
    

    }

    const mutations = {
        
        setCurrentuser(state, currentuser){
            state.CurrentUser = currentuser
        },

        
    }
    
    export default {
        namespaced:true,
        state,
        getters,
        actions,
        mutations
    }